import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { serviceAccountNameValidator, serviceAccountRoleValidator, } from '#validation';
import { ServiceAccountInvitationCreateSchema } from '#web-service-api/invitation/request';
import { ServiceIdentityCreateSchema } from './service-account-identity-create.dto';
export const WorkspaceServiceAccountCreateSchema = z.object({
    invitation: ServiceAccountInvitationCreateSchema,
    serviceIdentity: ServiceIdentityCreateSchema.optional(),
    serviceAccount: z.object({
        name: serviceAccountNameValidator,
        eAccountKeyByAdminKey: z.string(),
    }),
    role: serviceAccountRoleValidator.optional(),
});
export class WorkspaceServiceAccountCreateDto extends createZodDto(WorkspaceServiceAccountCreateSchema) {
}
